"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnWheel = void 0;
const react_1 = require("react");
const useOLMap_1 = require("../openlayers/useOLMap");
function useOnWheel(onWheel) {
    const map = useOLMap_1.useOLMap();
    const onWheelRef = react_1.useRef(onWheel);
    react_1.useEffect(() => {
        onWheelRef.current = onWheel;
    }, [onWheel]);
    react_1.useEffect(() => {
        const onWheel = (e) => {
            if (e.originalEvent.shiftKey) {
                onWheelRef.current(e);
            }
        };
        map.on('wheel', onWheel);
        return () => {
            map.un('wheel', onWheel);
        };
    }, [map]);
}
exports.useOnWheel = useOnWheel;
//# sourceMappingURL=useOnWheel.js.map